module.exports = __webpack_public_path__ + "static/img/A (15).22d091ce.png";